export const PAGED_LAYOUTS_ATTEMPT = 'admin/planimetry/PAGED_LAYOUTS_ATTEMPT'
export const PAGED_LAYOUTS_SUCCESS = 'admin/planimetry/PAGED_LAYOUTS_SUCCESS'
export const PAGED_LAYOUTS_FAILURE = 'admin/planimetry/PAGED_LAYOUTS_FAILURE'

export const LOAD_LAYOUT_OPTIONS_ATTEMPT =
  'admin/planimetry/LOAD_LAYOUT_OPTIONS_ATTEMPT'
export const LOAD_LAYOUT_OPTIONS_SUCCESS =
  'admin/planimetry/LOAD_LAYOUT_OPTIONS_SUCCESS'
export const LOAD_LAYOUT_OPTIONS_FAILURE =
  'admin/planimetry/LOAD_LAYOUT_OPTIONS_FAILURE'

export const PAGED_SECTORS_ATTEMPT = 'admin/planimetry/PAGED_SECTORS_ATTEMPT'
export const PAGED_SECTORS_SUCCESS = 'admin/planimetry/PAGED_SECTORS_SUCCESS'
export const PAGED_SECTORS_FAILURE = 'admin/planimetry/PAGED_SECTORS_FAILURE'

export const LOAD_SECTORS_ATTEMPT = 'admin/planimetry/LOAD_SECTORS_ATTEMPT'
export const LOAD_SECTORS_SUCCESS = 'admin/planimetry/LOAD_SECTORS_SUCCESS'
export const LOAD_SECTORS_FAILURE = 'admin/planimetry/LOAD_SECTORS_FAILURE'

export const LOAD_SEATS_ATTEMPT = 'admin/planimetry/LOAD_SEATS_ATTEMPT'
export const LOAD_SEATS_SUCCESS = 'admin/planimetry/LOAD_SEATS_SUCCESS'
export const LOAD_SEATS_FAILURE = 'admin/planimetry/LOAD_SEATS_FAILURE'

export const LOAD_SEATS_INFO_SELL_ATTEMPT =
  'admin/planimetry/LOAD_SEATS_INFO_SELL_ATTEMPT'
export const LOAD_SEATS_INFO_SELL_SUCCESS =
  'admin/planimetry/LOAD_SEATS_INFO_SELL_SUCCESS'
export const LOAD_SEATS_INFO_SELL_FAILURE =
  'admin/planimetry/LOAD_SEATS_INFO_SELL_FAILURE'

export const LOAD_LAYOUT_ATTEMPT = 'admin/planimetry/LOAD_LAYOUT_ATTEMPT'
export const LOAD_LAYOUT_SUCCESS = 'admin/planimetry/LOAD_LAYOUT_SUCCESS'
export const LOAD_LAYOUT_FAILURE = 'admin/planimetry/LOAD_LAYOUT_FAILURE'

export const LOAD_SECTOR_ATTEMPT = 'admin/planimetry/LOAD_SECTOR_ATTEMPT'
export const LOAD_SECTOR_SUCCESS = 'admin/planimetry/LOAD_SECTOR_SUCCESS'
export const LOAD_SECTOR_FAILURE = 'admin/planimetry/LOAD_SECTOR_FAILURE'

export const CREATE_LAYOUT_ATTEMPT = 'admin/planimetry/CREATE_LAYOUT_ATTEMPT'
export const CREATE_LAYOUT_SUCCESS = 'admin/planimetry/CREATE_LAYOUT_SUCCESS'
export const CREATE_LAYOUT_FAILURE = 'admin/planimetry/CREATE_LAYOUT_FAILURE'

export const UPDATE_LAYOUT_ATTEMPT = 'admin/planimetry/UPDATE_LAYOUT_ATTEMPT'
export const UPDATE_LAYOUT_SUCCESS = 'admin/planimetry/UPDATE_LAYOUT_SUCCESS'
export const UPDATE_LAYOUT_FAILURE = 'admin/planimetry/UPDATE_LAYOUT_FAILURE'

export const CREATE_SECTOR_ATTEMPT = 'admin/planimetry/CREATE_SECTOR_ATTEMPT'
export const CREATE_SECTOR_SUCCESS = 'admin/planimetry/CREATE_SECTOR_SUCCESS'
export const CREATE_SECTOR_FAILURE = 'admin/planimetry/CREATE_SECTOR_FAILURE'

export const UPDATE_SECTOR_ATTEMPT = 'admin/planimetry/UPDATE_SECTOR_ATTEMPT'
export const UPDATE_SECTOR_SUCCESS = 'admin/planimetry/UPDATE_SECTOR_SUCCESS'
export const UPDATE_SECTOR_FAILURE = 'admin/planimetry/UPDATE_SECTOR_FAILURE'

export const CREATE_SEATS_ATTEMPT = 'admin/planimetry/CREATE_SEATS_ATTEMPT'
export const CREATE_SEATS_SUCCESS = 'admin/planimetry/CREATE_SEATS_SUCCESS'
export const CREATE_SEATS_FAILURE = 'admin/planimetry/CREATE_SEATS_FAILURE'

export const UPDATE_SEATS_ATTEMPT = 'admin/planimetry/UPDATE_SEATS_ATTEMPT'
export const UPDATE_SEATS_SUCCESS = 'admin/planimetry/UPDATE_SEATS_SUCCESS'
export const UPDATE_SEATS_FAILURE = 'admin/planimetry/UPDATE_SEATS_FAILURE'

export const DELETE_SECTOR_ATTEMPT = 'admin/planimetry/DELETE_SECTOR_ATTEMPT'
export const DELETE_SECTOR_SUCCESS = 'admin/planimetry/DELETE_SECTOR_SUCCESS'
export const DELETE_SECTOR_FAILURE = 'admin/planimetry/DELETE_SECTOR_FAILURE'

export const DELETE_LAYOUT_ATTEMPT = 'admin/planimetry/DELETE_LAYOUT_ATTEMPT'
export const DELETE_LAYOUT_SUCCESS = 'admin/planimetry/DELETE_LAYOUT_SUCCESS'
export const DELETE_LAYOUT_FAILURE = 'admin/planimetry/DELETE_LAYOUT_FAILURE'

export const ASSIGN_LAYOUT_ATTEMPT = 'admin/planimetry/ASSIGN_LAYOUT_ATTEMPT'
export const ASSIGN_LAYOUT_SUCCESS = 'admin/planimetry/ASSIGN_LAYOUT_SUCCESS'
export const ASSIGN_LAYOUT_FAILURE = 'admin/planimetry/ASSIGN_LAYOUT_FAILURE'

export const LOAD_ASSIGNABLE_TICKETS_ATTEMPT =
  'admin/planimetry/LOAD_ASSIGNABLE_TICKETS_ATTEMPT'
export const LOAD_ASSIGNABLE_TICKETS_SUCCESS =
  'admin/planimetry/LOAD_ASSIGNABLE_TICKETS_SUCCESS'
export const LOAD_ASSIGNABLE_TICKETS_FAILURE =
  'admin/planimetry/LOAD_ASSIGNABLE_TICKETS_FAILURE'

export const ASSIGN_TICKET_TO_SECTOR_ATTEMPT =
  'admin/planimetry/ASSIGN_TICKET_TO_SECTOR_ATTEMPT'
export const ASSIGN_TICKET_TO_SECTOR_SUCCESS =
  'admin/planimetry/ASSIGN_TICKET_TO_SECTOR_SUCCESS'
export const ASSIGN_TICKET_TO_SECTOR_FAILURE =
  'admin/planimetry/ASSIGN_TICKET_TO_SECTOR_FAILURE'

export const RESET = 'admin/planimetry/RESET'
export const RESET_ACTIONS = 'admin/planimetry/RESET_ACTIONS'
export const RESET_PARAMS = 'admin/planimetry/RESET_PARAMS'
